import { useTypedSelector } from '@Features/store';
import useInvalidateRouteGroup from '@Hooks/Routes/useInvalidateRouteGroup';
import useRouteGroup from '@Hooks/Routes/useRouteGroup';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

/**
 * Analytics hub container. Same shape as the ClassRooms container: subtab
 * <Route>s are dropped — not just unlinked — when their platform flag is off,
 * so a direct URL cannot reach a page the mode has turned off.
 */
const Analytics: React.FC = () => {
	const routeGroup = useRouteGroup('analytics');
	const { classrooms_enabled, standalone_courses_enabled, bundles_enabled } = useTypedSelector(
		(state) => state.settings
	);
	const { path, url } = useRouteMatch();
	useInvalidateRouteGroup({
		mode: 'end',
		baseURL: '/dashboard/analytics',
		routeGroup: routeGroup,
		routePlacement: 2,
	});

	return (
		<Switch>
			{routeGroup && !Array.isArray(routeGroup) && (
				<>
					{/* Redirect must be wrapped in a Route — bare Redirects inside a
					    fragment fire unconditionally (see ClassRooms.tsx). */}
					<Route exact path={url}>
						<Redirect to={`${url}/overview`} />
					</Route>
					{routeGroup.routes.map((_) => {
						if (_.route === 'standalone-courses' && !standalone_courses_enabled) return null;
						if (_.route === 'bundles' && !(standalone_courses_enabled && bundles_enabled))
							return null;
						if (_.requiresClassrooms && !classrooms_enabled) return null;
						return (
							<Route key={_.route} strict path={`${path}/${_.route}`}>
								{_.component}
							</Route>
						);
					})}
				</>
			)}
		</Switch>
	);
};

export default Analytics;
